// extracted by mini-css-extract-plugin
export default {"row":"NotificationDiv_row__9seID","row1":"NotificationDiv_row1__vOfUB","bell":"NotificationDiv_bell__73WeH","p":"NotificationDiv_p__RZ2mm","span":"NotificationDiv_span__hyBSq"};